import { ErrorIngredient, ErrorOrigin, Errors, rawMaterialPayload } from "../CreateProductFlowInterfaces";
import isAllElementsEmpty from "./isAllElementsEmpty";

export const customValidation = (values: rawMaterialPayload) => {
  let errors: Errors = {};

  let errorIngredient: ErrorIngredient[] = new Array(
    values.ingredients.length
  );

  let ingredientList: String[] = [];
  let packagingMaterialList: String[] = [];

  values?.ingredients?.forEach((ingredient, index) => {
    let total = 0;
    let originArray: ErrorOrigin[] = [];

    ingredient?.origins?.forEach(origin => {
      if (
        origin.originShare !== undefined &&
        origin.originShare !== null
      ) {
        total += Number(origin.originShare);
      }
    });

    total = Number(total.toFixed(4))
    if (total !== 100) {
      // If the total is not 100, add error messages to each origin
      ingredient?.origins?.forEach((_, originIndex) => {
        originArray[originIndex] = {
          originShare: 'Total origin share should be 100%',
        };
      });
    }

    if (originArray.length > 0) {
      errorIngredient[index] = {
        origins: originArray,
      };
    }
    if (
      ingredientList.includes(ingredient.ingredientName ?? '')
    ) {
      errorIngredient.splice(index, 0, {
        ingredientName:
          'Ingredient already exist, please add another sub origin',
        origins: undefined,
      });
    } else {
      ingredientList.push(ingredient.ingredientName ?? '');
    }
  });
  // for multiple origins of packaging materails errors
  let errorPackaging: ErrorIngredient[] = new Array(
    values.packageMaterials.length
  );
  values?.packageMaterials?.forEach(
    (packagingMaterial, index) => {
      let total = 0;
      let originArray: ErrorOrigin[] = [];
      packagingMaterial?.origins?.forEach(origin => {
        if (
          origin.originShare !== undefined &&
          origin.originShare !== null
        ) {
          total += Number(origin.originShare);
        }
      });
      if (total !== 100) {
        // If the total is not 100, add error messages to each origin
        packagingMaterial?.origins?.forEach((_, originIndex) => {
          originArray[originIndex] = {
            originShare: 'Total origin share should be 100%',
          };
        });
      }
      if (originArray.length > 0) {
        errorPackaging[index] = {
          origins: originArray,
        };
      }

      if (
        packagingMaterialList.includes(
          packagingMaterial.packingMaterialName ?? ''
        )
      ) {
        errorPackaging.splice(index, 0, {
          packingMaterialName:
            'Packaging Material already exist, please add another sub origin',
          origins: undefined,
        });
      } else {
        packagingMaterialList.push(
          packagingMaterial.packingMaterialName ?? ''
        );
      }
    }
  );

  if (errorIngredient.length > 0) {
    errors.ingredients = errorIngredient;
  }
  if (errorPackaging.length > 0) {
    errors.packageMaterials = errorPackaging;
  }

  const isIngredientEmpty = isAllElementsEmpty(
    errors.ingredients ?? []
  );

  if (isIngredientEmpty) {
    delete errors['ingredients'];
  }
  const isPackagingMaterialEmpty = isAllElementsEmpty(
    errors.packageMaterials ?? []
  );
  if (isPackagingMaterialEmpty) {
    delete errors['packageMaterials'];
  }
  return errors;
}
